import React from 'react';
import { motion } from 'framer-motion';

import Interview from './Interview';
import Button from '../../shared/components/FormElements/Button/Button';
import './InterviewList.css';

const InterviewList = props => {
    if (props.items.length === 0) {
      return (
        <div className="not-found">
            <h3>No Interview Found.</h3>
            <Button to="/new">Create New Interview</Button>
        </div>
      );
    }
  
    return (
      <div className='interview-div'>
      <ul className="interview-list">
        {props.items.map((interview, index) => (
          <Interview
            key={interview._id}
            id={interview._id}
            userId={interview.userId}
            title={interview.title}
            description={interview.description}
            onDelete={props.onDeleteInterview}
            index={index}
          />
        ))}
      </ul>
      <motion.div 
        className='new-interview-button'
        initial={{ opacity: 0, scale: 1, x: -1000 }}
        animate={{ opacity: 1, scale: 1, x: 0 }}
        transition={{ delay: 0.25+0.1*(props.items.length+1), duration: 1 }}
      >
        <Button to="/new">CREATE NEW SESSION</Button>
      </motion.div>
      </div>
    );
  };
  
  export default InterviewList;